import { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import PdfViewerContainer from "../../../components/PdfViewerContainer";

const SELECT = "SELECT";
const FORM_NAME = "SBI_AGRI_LOAN";
const PDF_ENDPOINT = "/FillMyForm/SBI_AGRI_LOAN/Print.php";

const GROUPS = [
  {
    title: "Borrower Profile",
    fields: [
      { name: "bcode", label: "Branch Code", type: "text", required: true, maxLength: 6, numeric: true },
      { name: "cifno", label: "CIF No.", type: "text", required: false, maxLength: 11, numeric: true },
      { name: "name", label: "Applicnt Name", type: "text", required: true, maxLength: 40, alphaOnly: true },
      { name: "parent_spouse_name", label: "Father / Husband Name", type: "text", required: true, maxLength: 60, alphaOnly: true },
      { name: "dob", label: "Date of Birth", type: "date", required: true },
      { name: "education", label: "Educational Qualifications", type: "text", required: false, maxLength: 50 },
      { name: "gender", label: "Gender", type: "select", required: true,
        options: [["MALE","MALE"],["FEMALE","FEMALE"],["TRANSGENDER","TRANSGENDER"]] },
      { name: "marital_status", label: "Marital Status", type: "select", required: true,
        options: [["SINGLE","SINGLE"],["MARRIED","MARRIED"],["OTHERS","OTHERS"]] },
      { name: "category", label: "Category", type: "select", required: true,
        options: [["SC","SC"],["ST","ST"],["OBC","OBC"],["GENERAL","GENERAL"],["MINORITY/OTHERS","MINORITY / OTHERS"]] },
      { name: "mobile", label: "Mobile No.", type: "text", required: true, maxLength: 10, numeric: true },
      { name: "pan", label: "PAN Number", type: "text", required: false, maxLength: 10, uppercase: true },
      { name: "aadhaar", label: "Aadhaar Number", type: "text", required: true, maxLength: 12, numeric: true },
      { name: "voter_id", label: "Voter ID No.", type: "text", required: false, maxLength: 20, uppercase: true },
      { name: "mnrega_id", label: "MNREGA ID", type: "text", required: false, maxLength: 30, uppercase: true },
      { name: "farmer_id", label: "Farmer ID", type: "text", required: false, maxLength: 30, uppercase: true },
      { name: "land_id", label: "Land ID", type: "text", required: false, maxLength: 30, uppercase: true },
    ],
  },
  {
    title: "Current Address",
    fields: [
      { name: "add1", label: "Address Line 1", type: "text", required: true, maxLength: 41 },
      { name: "add2", label: "Address Line 2", type: "text", required: false, maxLength: 41 },
      { name: "village", label: "Village", type: "text", required: true, maxLength: 16 },
      { name: "city", label: "City", type: "text", required: true, maxLength: 20 },
      { name: "dist", label: "District", type: "text", required: true, maxLength: 20 },
      { name: "state", label: "State", type: "text", required: true, maxLength: 16 },
      { name: "pin", label: "PIN", type: "text", required: true, maxLength: 6, numeric: true },
    ],
  },

  {
    title: "Asset and Liabilities",
    fields: [
      { name: "income_source", heading: "Income Details", label: "Source of Income", type: "select", required: false,
        options: [["Agriculture","Agriculture"],["Allied Activity","Allied Activity"],["Business Income","Business Income"],["Other","Other"]] },
      { name: "income_amount", label: "Amount", type: "text", required: false, maxLength: 15, decimal: true },
      { name: "asset_type", heading: "Particulars of Asset", label: "Type of Asset", type: "select", required: false,
        options: [["Movable","Movable"],["Immovable","Immovable"],["Liquid","Liquid"]] },
      { name: "asset_amount", label: "Amount", type: "text", required: false, maxLength: 15, decimal: true },
      { name: "account_type", heading: "Account Details", label: "Account Type", type: "select", required: false,
        options: [["Saving","Saving"],["Current","Current"]] },
      { name: "ifsc_code", label: "IFSC Code", type: "text", required: false, maxLength: 11, uppercase: true },
      { name: "bank_name", label: "Bank Name", type: "text", required: false, maxLength: 16 },
      { name: "branch_name", label: "Branch Name", type: "text", required: false, maxLength: 16 },
      { name: "account_number", label: "Account Number", type: "text", required: false, maxLength: 17, numeric: true },
    ],
  },

  {
    title: "Loan Details",
    fields: [
      { name: "loan_amount", label: "Loan Amount", type: "text", required: false, maxLength: 10, numeric: true },
      { name: "loan_purpose", label: "Purpose of Loan", type: "text", required: false, maxLength: 40 },
      { name: "ftype", label: "Facility type", type: "select", required: false,
        options: [["CC","CC"],["TL","TL"],["OD","OD"],["DOD","DOD"],["OTHERS","OTHERS"]] },    
      { name: "product", label: "Product", type: "text", required: false, maxLength: 20 },      
      { name: "famount", label: "Amount (Lakhs)", type: "text", required: false, maxLength: 10, numeric: true },
      { name: "frepayment", label: "Repayment Frequency (Lakhs)", type: "text", required: false, maxLength: 10, numeric: true },      
      { name: "fmoratorium", label: "For TL Moratorium (Months)", type: "text", required: false, maxLength: 10, numeric: true },
      { name: "favalue", label: "Advance Value (Months)", type: "text", required: false, maxLength: 10, numeric: true },   
      { name: "takeover_loan", label: "Is this Takeover Laon", type: "select", required: false,
        options: [["Yes","Yes"], ["No","No"]] },    
      { name: "mop", label: "Mode of Operation", type: "select", required: false,
        options: [["Single","Single"], ["Joint","Joint"]] },             
    ],
  },


  {
    title: "Proposed Security",
    fields: [
      { name: "security", label: "Security", type: "select", required: false,
        options: [["primary","Primary"]] },    
      { name: "security_type", label: "Type of Security", type: "text", required: false, maxLength: 15 },      
      { name: "security_value", label: "Security Value (Lakhs)", type: "text", required: false, maxLength: 10, numeric: true },
      { name: "security_description", label: "Security Description", type: "text", required: false, maxLength: 100 },      
      { name: "security_owned_by", label: "Owned By", type: "select", required: false,
        options: [["owned","Owned"], ["Guarantors","Guarantor’s"]] }, 
    ],
  },

];


const allSourceFields = GROUPS.flatMap(group => group.fields);
const initialFormData = Object.fromEntries(allSourceFields.map(field => [field.name, field.type === "select" ? SELECT : ""]));

const TABLE_GROUPS = [];

const blankRow = columns => Object.fromEntries(columns.map(([name,,type]) => [name, type === "select" ? SELECT : ""]));
const initialTables = Object.fromEntries(TABLE_GROUPS.map(group => [group.key, [blankRow(group.columns)]]));

async function readJson(response) {
  const text = await response.text();
  if (!text.trim()) return null;
  try { return JSON.parse(text); } catch { throw new Error("The server returned invalid JSON."); }
}

export default function AGRILoan() {
  const [formData, setFormData] = useState(initialFormData);
  const [tableData, setTableData] = useState(initialTables);
  const [errors, setErrors] = useState({});
  const [tableErrors, setTableErrors] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [maxAllowedTab, setMaxAllowedTab] = useState(0);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const nextButtonRef = useRef(null);

  const tabs = useMemo(() => [
    ...GROUPS.map(g => ({ type:"fields", ...g })),
    ...TABLE_GROUPS.map(g => ({ type:"table", ...g })),
    { type:"preview", title:"Preview" },
  ], []);

  const activeTab = tabs[currentTab] || tabs[0];
  const currentFields = activeTab?.type === "fields" ? activeTab.fields : [];

  useEffect(() => {
    const first = currentFields[0];
    if (!first) return;
    const frame = requestAnimationFrame(() => document.getElementById(first.name)?.focus());
    return () => cancelAnimationFrame(frame);
  }, [currentTab]);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const response = await fetch(`/backend/api/autofill.php?form=${encodeURIComponent(FORM_NAME)}`, {
          credentials:"include", cache:"no-store", headers:{Accept:"application/json"}, signal:controller.signal,
        });
        const result = await readJson(response);
        if (!response.ok || !result?.success || !result?.found || !result?.data) return;
        const d = result.data;
        setFormData(p => ({
          ...p,
          city:p.city || d.city || "",
          dist:p.dist || d.dist || "",
          state:p.state || d.state || "",
          pin:p.pin || d.pin || "",
        }));
      } catch (error) {
        if (error.name !== "AbortError") console.error("SBI_AGRI_LOAN autofill error:", error);
      }
    })();
    return () => controller.abort();
  }, []);

  useEffect(() => () => {
    if (pdfUrl?.startsWith("blob:")) URL.revokeObjectURL(pdfUrl);
  }, [pdfUrl]);

  const updateField = (field, raw) => {
    let value = raw;
    if (field.numeric) value = value.replace(/\D/g, "");
    if (field.decimal) value = value.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");
    if (field.alphaOnly) value = value.replace(/[^A-Za-z ]/g, "");
    if (field.uppercase || ["pan","voter_id","mnrega_id","farmer_id","land_id"].includes(field.name)) value = value.toUpperCase();
    setFormData(p => ({...p,[field.name]:value}));
    setErrors(p => ({...p,[field.name]:""}));
  };

  const validateField = field => {
    const value = String(formData[field.name] ?? "").trim();
    if (field.required && (field.type === "select" ? !value || value === SELECT : !value)) return `${field.label} is required.`;
    if (field.alphaOnly && value && !/^[A-Za-z ]+$/.test(value)) return `${field.label} must contain alphabet letters only.`;
    if (field.name === "aadhaar" && value && !/^\d{12}$/.test(value)) return "Aadhaar number must contain exactly 12 digits.";
    if (["pin","current_pin","permanent_pin"].includes(field.name) && value && !/^\d{6}$/.test(value)) return "PIN must contain exactly 6 digits.";
    if (["mobile","alternate_mobile"].includes(field.name) && value && !/^\d{10}$/.test(value)) return "Mobile number must contain exactly 10 digits.";
    if (field.name === "pan" && value && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) return "Enter a valid PAN number (e.g. ABCDE1234F).";
    return "";
  };

  const validateFields = fields => {
    const next = {};
    fields.forEach(field => {
      const message = validateField(field);
      if (message) next[field.name] = message;
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const normalizeTableValue = (type, raw) => {
    if (type === "numeric") return raw.replace(/\D/g,"");
    if (type === "decimal") return raw.replace(/[^\d.]/g,"").replace(/(\..*)\./g,"$1");
    if (type === "alpha") return raw.replace(/[^A-Za-z ]/g,"");
    if (type === "upper") return raw.toUpperCase();
    return raw;
  };

  const updateTable = (key, index, column, type, raw) => {
    const value = normalizeTableValue(type, raw);
    setTableData(p => ({...p,[key]:p[key].map((row,i)=>i===index?{...row,[column]:value}:row)}));
    setTableErrors(p => ({...p,[`${key}.${index}.${column}`]:""}));
  };

  const addRow = group => setTableData(p => ({...p,[group.key]:[...p[group.key],blankRow(group.columns)]}));
  const removeRow = (group,index) => setTableData(p => ({
    ...p,[group.key]:p[group.key].length === 1 ? p[group.key] : p[group.key].filter((_,i)=>i!==index)
  }));

  const validateTable = group => {
    const next = {};
    tableData[group.key].forEach((row,index) => {
      group.columns.forEach(([name,label,type]) => {
        const value = String(row[name] ?? "").trim();
        if (!value || value === SELECT) return; // repeatable rows are optional unless user enters data
        if (type === "alpha" && !/^[A-Za-z ]+$/.test(value)) next[`${group.key}.${index}.${name}`] = `${label} must contain alphabet letters only.`;
      });
    });
    setTableErrors(p => ({...p,...next}));
    return Object.keys(next).length === 0;
  };

  const validateCurrent = () => activeTab.type === "fields" ? validateFields(currentFields) : activeTab.type === "table" ? validateTable(activeTab) : true;

  const goNext = () => {
    if (!validateCurrent()) return;
    const next = currentTab + 1;
    setCurrentTab(next);
    setMaxAllowedTab(p => Math.max(p,next));
    window.scrollTo({top:0,behavior:"smooth"});
  };

  const goPrevious = () => {
    setCurrentTab(p => Math.max(0,p-1));
    window.scrollTo({top:0,behavior:"smooth"});
  };

  //Open PDFViewer

  const handleSubmit = async event => {
    event.preventDefault();
    const allFieldErrors = {};
    allSourceFields.forEach(field => {
      const message = validateField(field);
      if (message) allFieldErrors[field.name] = message;
    });
    setErrors(allFieldErrors);
    if (Object.keys(allFieldErrors).length) {
      const firstInvalid = allSourceFields.find(f => allFieldErrors[f.name]);
      const tabIndex = tabs.findIndex(t => t.type === "fields" && t.fields.some(f => f.name === firstInvalid?.name));
      if (tabIndex >= 0) setCurrentTab(tabIndex);
      return;
    }

    setPdfLoading(true);
    setPdfError("");
    try {
      const body = new FormData();
      Object.entries(formData).forEach(([name,value]) => body.append(name,value === SELECT ? "" : String(value ?? "")));
      Object.entries(tableData).forEach(([name,value]) => body.append(name,JSON.stringify(value.map(row =>
        Object.fromEntries(Object.entries(row).map(([k,v]) => [k,v === SELECT ? "" : v]))
      ))));

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(),60000);
      let response;
      try {
        response = await fetch(PDF_ENDPOINT,{method:"POST",body,credentials:"include",headers:{Accept:"application/pdf"},signal:controller.signal});
      } finally { clearTimeout(timeout); }

      if (!response.ok) throw new Error((await response.text()) || `PDF generation failed (${response.status}).`);
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/pdf")) throw new Error((await response.text()) || "Print.php did not return a PDF file.");

      const url = URL.createObjectURL(await response.blob());
      setPdfUrl(old => { if (old?.startsWith("blob:")) URL.revokeObjectURL(old); return url; });
      setShowPdf(true);
    } catch (error) {
      setPdfError(error.name === "AbortError" ? "PDF generation timed out." : error.message || "Unable to generate PDF.");
    } finally { setPdfLoading(false); }
  };


// //   //Open in New Tab

//   const handleSubmit = event => {
//   event.preventDefault();

//   const allFieldErrors = {};

//   allSourceFields.forEach(field => {
//     const message = validateField(field);
//     if (message) allFieldErrors[field.name] = message;
//   });

//   setErrors(allFieldErrors);

//   if (Object.keys(allFieldErrors).length) {
//     const firstInvalid = allSourceFields.find(
//       f => allFieldErrors[f.name]
//     );

//     const tabIndex = tabs.findIndex(
//       t =>
//         t.type === "fields" &&
//         t.fields.some(f => f.name === firstInvalid?.name)
//     );

//     if (tabIndex >= 0) setCurrentTab(tabIndex);
//     return;
//   }

//   setPdfError("");

//   // Create normal HTML form
//   const form = document.createElement("form");

//   form.method = "POST";
//   form.action = PDF_ENDPOINT;
//   form.target = "_blank";
//   form.style.display = "none";

//   // ADD NORMAL FORM DATA
//   Object.entries(formData).forEach(([name, value]) => {
//     const input = document.createElement("input");

//     input.type = "hidden";
//     input.name = name;
//     input.value =
//       value === SELECT ? "" : String(value ?? "");

//     form.appendChild(input);
//   });

//   // ADD TABLE DATA AS JSON
//   Object.entries(tableData).forEach(([name, value]) => {
//     const input = document.createElement("input");

//     input.type = "hidden";
//     input.name = name;

//     input.value = JSON.stringify(
//       value.map(row =>
//         Object.fromEntries(
//           Object.entries(row).map(([key, val]) => [
//             key,
//             val === SELECT ? "" : val
//           ])
//         )
//       )
//     );

//     form.appendChild(input);
//   });

//   document.body.appendChild(form);

//   // POST TO Print.php AND OPEN PDF IN NEW TAB
//   form.submit();

//   // REMOVE TEMPORARY FORM
//   document.body.removeChild(form);
// };

  const renderField = field => {
    const error = errors[field.name];
    return <div key={field.name} className="space-y-2">
      <Label htmlFor={field.name}>{field.label}{field.required && <span className="text-red-500"> *</span>}</Label>
      {field.type === "select" ? (
        <select id={field.name} name={field.name} value={formData[field.name]}
          onChange={e=>updateField(field,e.target.value)}
          className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ${error?"border-red-500":""}`}>
          <option value={SELECT}>SELECT</option>
          {(field.options || []).map(([value,label]) => <option key={`${field.name}-${value}`} value={value}>{label}</option>)}
        </select>
      ) : (
        <Input id={field.name} name={field.name} type={field.type || "text"} value={formData[field.name]}
          maxLength={field.maxLength} placeholder={field.label} className={error?"border-red-500":""}
          onChange={e=>updateField(field,e.target.value)} />
      )}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>;
  };

  // Render the Asset and Liabilities fields in three bordered groups.
  const renderGroupedFields = fields => {
    const groups = [];
    fields.forEach(field => {
      if (field.heading || groups.length === 0) {
        groups.push({ title: field.heading || "", fields: [] });
      }
      groups[groups.length - 1].fields.push(field);
    });

    return <div className="space-y-6">
      {groups.map((group, index) => <div
        key={group.title || index}
        className="rounded-lg border border-gray-300 p-5 space-y-5"
      >
        {group.title && <h3 className="border-b pb-3 text-lg font-semibold text-foreground">{group.title}</h3>}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {group.fields.map(renderField)}
        </div>
      </div>)}
    </div>;
  };

  // Read-only review of every field before generating the PDF.
  const renderPreview = () => <Card>
    <CardHeader>
      <CardTitle>Preview Application</CardTitle>
      <p className="text-sm text-muted-foreground">Review your details. Use Edit to make changes, then return to Preview to submit.</p>
    </CardHeader>
    <CardContent className="space-y-6">
      {GROUPS.map(group => <div key={group.title} className="rounded-lg border border-gray-300 p-5 space-y-4">
        <div className="flex items-center justify-between gap-3 border-b pb-3">
          <h3 className="text-lg font-semibold">{group.title}</h3>
          <Button type="button" variant="outline" onClick={() => setCurrentTab(tabs.findIndex(tab => tab.title === group.title))}>Edit</Button>
        </div>
        {group.title === "Asset and Liabilities" ? (() => {
          const subgroups = [];
          group.fields.forEach(field => {
            if (field.heading || !subgroups.length) subgroups.push({ title:field.heading || "", fields:[] });
            subgroups[subgroups.length - 1].fields.push(field);
          });
          return subgroups.map(subgroup => <div key={subgroup.title} className="space-y-3">
            <h4 className="font-medium">{subgroup.title}</h4>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              {subgroup.fields.map(field => <div key={field.name} className="min-w-0">
                <p className="text-sm text-muted-foreground">{field.label}</p>
                <p className="break-words font-medium">{formData[field.name] && formData[field.name] !== SELECT ? formData[field.name] : "—"}</p>
              </div>)}
            </div>
          </div>);
        })() : <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {group.fields.map(field => <div key={field.name} className="min-w-0">
            <p className="text-sm text-muted-foreground">{field.label}</p>
            <p className="break-words font-medium">{formData[field.name] && formData[field.name] !== SELECT ? formData[field.name] : "—"}</p>
          </div>)}
        </div>}
      </div>)}
      {TABLE_GROUPS.map(group => <div key={group.key} className="rounded-lg border p-5 space-y-3">
        <div className="flex items-center justify-between border-b pb-3">
          <h3 className="text-lg font-semibold">{group.title}</h3>
          <Button type="button" variant="outline" onClick={() => setCurrentTab(tabs.findIndex(tab => tab.type === "table" && tab.key === group.key))}>Edit</Button>
        </div>
        {tableData[group.key].map((row, index) => <div key={index} className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {group.columns.map(([name,label]) => <div key={name}>
            <p className="text-sm text-muted-foreground">{label} #{index + 1}</p>
            <p className="break-words font-medium">{row[name] && row[name] !== SELECT ? row[name] : "—"}</p>
          </div>)}
        </div>)}
      </div>)}
    </CardContent>
  </Card>;

  const renderTable = group => <Card>
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle>{group.title}</CardTitle>
      <Button type="button" variant="outline" onClick={()=>addRow(group)}>+ Add Row</Button>
    </CardHeader>
    <CardContent className="space-y-6">
      {tableData[group.key].map((row,index)=><div key={index} className="rounded-lg border p-4">
        <div className="mb-4 flex items-center justify-between">
          <p className="font-medium">{group.title} #{index+1}</p>
          {tableData[group.key].length>1 && <Button type="button" variant="outline" onClick={()=>removeRow(group,index)}>Remove</Button>}
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {group.columns.map(([name,label,type,options])=>{
            const key=`${group.key}.${index}.${name}`, error=tableErrors[key];
            return <div key={name} className="space-y-2"><Label>{label}</Label>
              {type==="select"?<select value={row[name]} onChange={e=>updateTable(group.key,index,name,type,e.target.value)}
                className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ${error?"border-red-500":""}`}>
                <option value={SELECT}>SELECT</option>{options.map(o=><option key={o} value={o}>{o}</option>)}</select>
              :<Input value={row[name]} placeholder={label} className={error?"border-red-500":""}
                onChange={e=>updateTable(group.key,index,name,type,e.target.value)}/>}
              {error&&<p className="text-sm text-red-500">{error}</p>}
            </div>;
          })}
        </div>
      </div>)}
    </CardContent>
  </Card>;

  if (showPdf && pdfUrl) {
    return <PdfViewerContainer pdfUrl={pdfUrl} title="SBI Agriculture Loan Application Form" onBack={()=>setShowPdf(false)} />;
  }

  const isLastTab = currentTab === tabs.length-1;

  return <div className="min-h-screen bg-background p-6">
    <div className="mx-auto max-w-7xl">
      <Card className="mb-6"><CardHeader>
        <CardTitle className="text-3xl">🌾 SBI Agriculture Loan Application Form</CardTitle>
        <p className="text-muted-foreground">Complete the form, review all details in Preview, then submit to generate the PDF.</p>
      </CardHeader></Card>

      <div className="mb-8 grid gap-3" style={{gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))"}}>
        {tabs.map((tab,index)=><Button key={`${tab.type}-${tab.title}`} type="button"
          variant={currentTab===index?"default":"outline"} disabled={index>maxAllowedTab}
          onClick={()=>setCurrentTab(index)}>{index+1}. {tab.title}</Button>)}
      </div>

      {activeTab.type === "preview" ? renderPreview() : activeTab.type==="fields" ? <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>{activeTab.title}</CardTitle>
        </CardHeader>
        <CardContent>
          {activeTab.title === "Asset and Liabilities" ? renderGroupedFields(currentFields) :
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">{currentFields.map(renderField)}</div>}
        </CardContent>
      </Card> : renderTable(activeTab)}

      {pdfError && <p className="mt-4 rounded-lg border border-red-300 bg-red-50 p-3 text-red-700">{pdfError}</p>}

      <div className="mt-6 flex items-center justify-between">
        <Button type="button" variant="outline" onClick={goPrevious} disabled={currentTab===0}>← Previous</Button>
        {isLastTab ? <Button type="button" ref={nextButtonRef} onClick={handleSubmit} disabled={pdfLoading}>
          {pdfLoading?"Generating PDF...":"Submit & Open PDF"}</Button>
        :<Button type="button" ref={nextButtonRef} onClick={goNext}>Next →</Button>}
      </div>
    </div>
  </div>;
}
